module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 12);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@tkey/common-types");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("bn.js");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("@toruslabs/eccrypto");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/getPrototypeOf");

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inherits");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/possibleConstructorReturn");

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "ShareTransferError", function() { return /* reexport */ errors; });
__webpack_require__.d(__webpack_exports__, "ShareRequest", function() { return /* reexport */ src_ShareRequest; });
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ src_ShareTransferModule; });
__webpack_require__.d(__webpack_exports__, "SHARE_TRANSFER_MODULE_NAME", function() { return /* reexport */ SHARE_TRANSFER_MODULE_NAME; });
__webpack_require__.d(__webpack_exports__, "ShareTransferModule", function() { return /* reexport */ src_ShareTransferModule; });
__webpack_require__.d(__webpack_exports__, "ShareTransferStore", function() { return /* reexport */ /* Cannot get final name for export "ShareTransferStore" in "./src/ShareTransferModule.ts" (known exports: SHARE_TRANSFER_MODULE_NAME default, known reexports: ) */ undefined; });
__webpack_require__.d(__webpack_exports__, "ShareTransferStorePointer", function() { return /* reexport */ src_ShareTransferStorePointer; });

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(4);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(6);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/assertThisInitialized"
var assertThisInitialized_ = __webpack_require__(7);
var assertThisInitialized_default = /*#__PURE__*/__webpack_require__.n(assertThisInitialized_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/inherits"
var inherits_ = __webpack_require__(10);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/possibleConstructorReturn"
var possibleConstructorReturn_ = __webpack_require__(11);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/getPrototypeOf"
var getPrototypeOf_ = __webpack_require__(9);
var getPrototypeOf_default = /*#__PURE__*/__webpack_require__.n(getPrototypeOf_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "@tkey/common-types"
var common_types_ = __webpack_require__(3);

// CONCATENATED MODULE: ./src/errors.ts








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = getPrototypeOf_default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = getPrototypeOf_default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return possibleConstructorReturn_default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var errors_ShareTransferError = /*#__PURE__*/function (_TkeyError) {
  inherits_default()(ShareTransferError, _TkeyError);

  var _super = _createSuper(ShareTransferError);

  function ShareTransferError(code, message) {
    var _this;

    classCallCheck_default()(this, ShareTransferError);

    // takes care of stack and proto
    _this = _super.call(this, code, message); // Set name explicitly as minification can mangle class names

    defineProperty_default()(assertThisInitialized_default()(_this), "code", void 0);

    defineProperty_default()(assertThisInitialized_default()(_this), "message", void 0);

    Object.defineProperty(assertThisInitialized_default()(_this), "name", {
      value: "ShareTransferError"
    });
    return _this;
  }

  createClass_default()(ShareTransferError, null, [{
    key: "fromCode",
    value: function fromCode(code) {
      var extraMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      return new ShareTransferError(code, "".concat(ShareTransferError.messages[code]).concat(extraMessage));
    }
  }, {
    key: "default",
    value: function _default() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return new ShareTransferError(8000, "".concat(ShareTransferError.messages[8000]).concat(extraMessage));
    } // Custom methods

  }, {
    key: "missingEncryptionKey",
    value: function missingEncryptionKey() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return ShareTransferError.fromCode(8010, extraMessage);
    }
  }, {
    key: "requestExists",
    value: function requestExists() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return ShareTransferError.fromCode(8011, extraMessage);
    }
  }, {
    key: "userCancelledRequest",
    value: function userCancelledRequest() {
      var extraMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return ShareTransferError.fromCode(8012, extraMessage);
    }
  }]);

  return ShareTransferError;
}(common_types_["TkeyError"]);

defineProperty_default()(errors_ShareTransferError, "messages", {
  8000: "Custom",
  // Misc
  8010: "Missing current enc key",
  8011: "Current request already exists",
  8012: "User cancelled request"
});

/* harmony default export */ var errors = (errors_ShareTransferError);
// CONCATENATED MODULE: ./src/ShareRequest.ts



var ShareRequest_ShareRequest = function ShareRequest(_ref) {
  var encPubKey = _ref.encPubKey,
      encShareInTransit = _ref.encShareInTransit,
      availableShareIndexes = _ref.availableShareIndexes,
      userAgent = _ref.userAgent,
      timestamp = _ref.timestamp;

  classCallCheck_default()(this, ShareRequest);

  defineProperty_default()(this, "encPubKey", void 0);

  defineProperty_default()(this, "encShareInTransit", void 0);

  defineProperty_default()(this, "availableShareIndexes", void 0);

  defineProperty_default()(this, "userAgent", void 0);

  defineProperty_default()(this, "timestamp", void 0);

  var testEncPubKey = encPubKey;

  if (testEncPubKey.type === "Buffer") {
    this.encPubKey = Buffer.from(testEncPubKey.data);
  } else {
    this.encPubKey = encPubKey;
  }

  this.availableShareIndexes = availableShareIndexes;
  this.encShareInTransit = encShareInTransit;
  this.userAgent = userAgent;
  this.timestamp = timestamp;
};

/* harmony default export */ var src_ShareRequest = (ShareRequest_ShareRequest);
// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(2);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/regenerator"
var regenerator_ = __webpack_require__(0);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// EXTERNAL MODULE: external "@toruslabs/eccrypto"
var eccrypto_ = __webpack_require__(8);

// EXTERNAL MODULE: external "bn.js"
var external_bn_js_ = __webpack_require__(5);
var external_bn_js_default = /*#__PURE__*/__webpack_require__.n(external_bn_js_);

// CONCATENATED MODULE: ./src/ShareTransferStorePointer.ts




var ShareTransferStorePointer_ShareTransferStorePointer = function ShareTransferStorePointer(_ref) {
  var pointer = _ref.pointer;

  classCallCheck_default()(this, ShareTransferStorePointer);

  defineProperty_default()(this, "pointer", void 0);

  this.pointer = new external_bn_js_default.a(pointer, "hex");
};

/* harmony default export */ var src_ShareTransferStorePointer = (ShareTransferStorePointer_ShareTransferStorePointer);
// CONCATENATED MODULE: ./src/ShareTransferModule.ts










 // @flow

var SHARE_TRANSFER_MODULE_NAME = "shareTransfer";

var ShareTransferModule_ShareTransferModule = /*#__PURE__*/function () {
  function ShareTransferModule() {
    classCallCheck_default()(this, ShareTransferModule);

    defineProperty_default()(this, "moduleName", void 0);

    defineProperty_default()(this, "tbSDK", void 0);

    defineProperty_default()(this, "currentEncKey", void 0);

    defineProperty_default()(this, "requestStatusCheckId", void 0);

    defineProperty_default()(this, "requestStatusCheckInterval", void 0);

    this.moduleName = SHARE_TRANSFER_MODULE_NAME;
    this.requestStatusCheckInterval = 1000;
  }

  createClass_default()(ShareTransferModule, [{
    key: "setModuleReferences",
    value: function setModuleReferences(tbSDK) {
      this.tbSDK = tbSDK;
    }
  }, {
    key: "setRequestStatusCheckInterval",
    value: function setRequestStatusCheckInterval(interval) {
      this.requestStatusCheckInterval = interval;
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var metadata, rawShareTransferStorePointer, shareTransferStorePointer;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                metadata = this.tbSDK.getMetadata();
                rawShareTransferStorePointer = metadata.getGeneralStoreDomain(this.moduleName);

                if (rawShareTransferStorePointer) {
                  _context.next = 9;
                  break;
                }

                shareTransferStorePointer = {
                  pointer: new external_bn_js_default.a(Object(eccrypto_["generatePrivate"])())
                };
                metadata.setGeneralStoreDomain(this.moduleName, shareTransferStorePointer);
                _context.next = 7;
                return this.tbSDK.syncShareMetadata();

              case 7:
                _context.next = 10;
                break;

              case 9:
                shareTransferStorePointer = new src_ShareTransferStorePointer(rawShareTransferStorePointer);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initialize() {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "requestNewShare",
    value: function () {
      var _requestNewShare = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(userAgent, availableShareIndexes, callback) {
        var _this = this;

        var newShareTransferStore, encPubKeyX;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.currentEncKey) {
                  _context3.next = 2;
                  break;
                }

                throw errors.requestExists("".concat(this.currentEncKey.toString("hex")));

              case 2:
                this.currentEncKey = new external_bn_js_default.a(Object(eccrypto_["generatePrivate"])());
                _context3.next = 5;
                return this.getShareTransferStore();

              case 5:
                newShareTransferStore = _context3.sent;
                encPubKeyX = Object(common_types_["getPubKeyPoint"])(this.currentEncKey).x.toString("hex");
                newShareTransferStore[encPubKeyX] = new src_ShareRequest({
                  encPubKey: Object(common_types_["getPubKeyECC"])(this.currentEncKey),
                  encShareInTransit: undefined,
                  availableShareIndexes: availableShareIndexes,
                  userAgent: userAgent,
                  timestamp: Date.now()
                });
                _context3.next = 10;
                return this.setShareTransferStore(newShareTransferStore);

              case 10:
                // watcher
                if (callback) {
                  this.requestStatusCheckId = Number(setInterval( /*#__PURE__*/asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                    var latestShareTransferStore, shareStoreBuf, receivedShare;
                    return regenerator_default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return _this.getShareTransferStore();

                          case 3:
                            latestShareTransferStore = _context2.sent;

                            if (_this.currentEncKey) {
                              _context2.next = 6;
                              break;
                            }

                            throw errors.missingEncryptionKey();

                          case 6:
                            if (!latestShareTransferStore[encPubKeyX].encShareInTransit) {
                              _context2.next = 17;
                              break;
                            }

                            _context2.next = 9;
                            return Object(common_types_["decrypt"])(Object(common_types_["toPrivKeyECC"])(_this.currentEncKey), latestShareTransferStore[encPubKeyX].encShareInTransit);

                          case 9:
                            shareStoreBuf = _context2.sent;
                            receivedShare = common_types_["ShareStore"].fromJSON(JSON.parse(shareStoreBuf.toString()));
                            _context2.next = 13;
                            return _this.tbSDK.inputShareStoreSafe(receivedShare);

                          case 13:
                            _this._cleanUpCurrentRequest();

                            callback(null, receivedShare);
                            _context2.next = 18;
                            break;

                          case 17:
                            if (!latestShareTransferStore[encPubKeyX]) {
                              _this._cleanUpCurrentRequest();

                              callback(errors.userCancelledRequest());
                            }

                          case 18:
                            _context2.next = 24;
                            break;

                          case 20:
                            _context2.prev = 20;
                            _context2.t0 = _context2["catch"](0);

                            _this._cleanUpCurrentRequest();

                            callback(_context2.t0);

                          case 24:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[0, 20]]);
                  })), this.requestStatusCheckInterval));
                }

                return _context3.abrupt("return", encPubKeyX);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function requestNewShare(_x, _x2, _x3) {
        return _requestNewShare.apply(this, arguments);
      }

      return requestNewShare;
    }()
  }, {
    key: "_cleanUpCurrentRequest",
    value: function _cleanUpCurrentRequest() {
      this.currentEncKey = undefined;
      clearInterval(this.requestStatusCheckId);
    }
  }, {
    key: "lookForRequests",
    value: function () {
      var _lookForRequests = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var shareTransferStore;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getShareTransferStore();

              case 2:
                shareTransferStore = _context4.sent;
                return _context4.abrupt("return", Object.keys(shareTransferStore));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function lookForRequests() {
        return _lookForRequests.apply(this, arguments);
      }

      return lookForRequests;
    }()
  }, {
    key: "approveRequest",
    value: function () {
      var _approveRequest = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(encPubKeyX, shareStore) {
        var shareTransferStore, bufferedShare, store, availableShareIndexes, metadata, latestPolynomial, latestPolynomialId, indexes, filtered, share, shareRequest;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getShareTransferStore();

              case 2:
                shareTransferStore = _context5.sent;

                if (shareStore) {
                  bufferedShare = Buffer.from(JSON.stringify(shareStore));
                } else {
                  store = new src_ShareRequest(shareTransferStore[encPubKeyX]);
                  availableShareIndexes = store.availableShareIndexes;
                  metadata = this.tbSDK.getMetadata();
                  latestPolynomial = metadata.getLatestPublicPolynomial();
                  latestPolynomialId = latestPolynomial.getPolynomialID();
                  indexes = metadata.getShareIndexesForPolynomial(latestPolynomialId);
                  filtered = indexes.filter(function (el) {
                    return !availableShareIndexes.includes(el);
                  });
                  share = this.tbSDK.outputShareStore(filtered[0]);
                  bufferedShare = Buffer.from(JSON.stringify(share));
                }

                shareRequest = new src_ShareRequest(shareTransferStore[encPubKeyX]);
                _context5.next = 7;
                return Object(common_types_["encrypt"])(shareRequest.encPubKey, bufferedShare);

              case 7:
                shareTransferStore[encPubKeyX].encShareInTransit = _context5.sent;
                _context5.next = 10;
                return this.setShareTransferStore(shareTransferStore);

              case 10:
                this.currentEncKey = undefined;

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function approveRequest(_x4, _x5) {
        return _approveRequest.apply(this, arguments);
      }

      return approveRequest;
    }()
  }, {
    key: "approveRequestWithShareIndex",
    value: function () {
      var _approveRequestWithShareIndex = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(encPubKeyX, shareIndex) {
        var deviceShare;
        return regenerator_default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                deviceShare = this.tbSDK.outputShareStore(shareIndex);
                return _context6.abrupt("return", this.approveRequest(encPubKeyX, deviceShare));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function approveRequestWithShareIndex(_x6, _x7) {
        return _approveRequestWithShareIndex.apply(this, arguments);
      }

      return approveRequestWithShareIndex;
    }()
  }, {
    key: "getShareTransferStore",
    value: function () {
      var _getShareTransferStore = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
        var metadata, shareTransferStorePointer, storageLayer;
        return regenerator_default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                metadata = this.tbSDK.getMetadata();
                shareTransferStorePointer = new src_ShareTransferStorePointer(metadata.getGeneralStoreDomain(this.moduleName));
                storageLayer = this.tbSDK.getStorageLayer();
                return _context7.abrupt("return", storageLayer.getMetadata({
                  privKey: shareTransferStorePointer.pointer
                }));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getShareTransferStore() {
        return _getShareTransferStore.apply(this, arguments);
      }

      return getShareTransferStore;
    }()
  }, {
    key: "setShareTransferStore",
    value: function () {
      var _setShareTransferStore = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8(shareTransferStore) {
        var metadata, shareTransferStorePointer, storageLayer;
        return regenerator_default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                metadata = this.tbSDK.getMetadata();
                shareTransferStorePointer = new src_ShareTransferStorePointer(metadata.getGeneralStoreDomain(this.moduleName));
                storageLayer = this.tbSDK.getStorageLayer();
                _context8.next = 5;
                return storageLayer.setMetadata({
                  input: shareTransferStore,
                  privKey: shareTransferStorePointer.pointer
                });

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setShareTransferStore(_x8) {
        return _setShareTransferStore.apply(this, arguments);
      }

      return setShareTransferStore;
    }()
  }, {
    key: "startRequestStatusCheck",
    value: function () {
      var _startRequestStatusCheck = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10(encPubKeyX, deleteRequestAfterCompletion) {
        var _this2 = this;

        return regenerator_default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", new Promise(function (resolve, reject) {
                  _this2.requestStatusCheckId = Number(setInterval( /*#__PURE__*/asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
                    var latestShareTransferStore, shareStoreBuf, receivedShare;
                    return regenerator_default.a.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.prev = 0;
                            _context9.next = 3;
                            return _this2.getShareTransferStore();

                          case 3:
                            latestShareTransferStore = _context9.sent;

                            if (_this2.currentEncKey) {
                              _context9.next = 6;
                              break;
                            }

                            throw errors.missingEncryptionKey();

                          case 6:
                            if (latestShareTransferStore[encPubKeyX]) {
                              _context9.next = 11;
                              break;
                            }

                            _this2._cleanUpCurrentRequest();

                            reject(errors.userCancelledRequest());
                            _context9.next = 23;
                            break;

                          case 11:
                            if (!latestShareTransferStore[encPubKeyX].encShareInTransit) {
                              _context9.next = 23;
                              break;
                            }

                            _context9.next = 14;
                            return Object(common_types_["decrypt"])(Object(common_types_["toPrivKeyECC"])(_this2.currentEncKey), latestShareTransferStore[encPubKeyX].encShareInTransit);

                          case 14:
                            shareStoreBuf = _context9.sent;
                            receivedShare = common_types_["ShareStore"].fromJSON(JSON.parse(shareStoreBuf.toString()));
                            _context9.next = 18;
                            return _this2.tbSDK.inputShareStoreSafe(receivedShare);

                          case 18:
                            if (!deleteRequestAfterCompletion) {
                              _context9.next = 21;
                              break;
                            }

                            _context9.next = 21;
                            return _this2.deleteShareTransferStore(encPubKeyX);

                          case 21:
                            _this2._cleanUpCurrentRequest();

                            resolve(receivedShare);

                          case 23:
                            _context9.next = 29;
                            break;

                          case 25:
                            _context9.prev = 25;
                            _context9.t0 = _context9["catch"](0);

                            _this2._cleanUpCurrentRequest();

                            reject(_context9.t0);

                          case 29:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9, null, [[0, 25]]);
                  })), _this2.requestStatusCheckInterval));
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function startRequestStatusCheck(_x9, _x10) {
        return _startRequestStatusCheck.apply(this, arguments);
      }

      return startRequestStatusCheck;
    }()
  }, {
    key: "cancelRequestStatusCheck",
    value: function () {
      var _cancelRequestStatusCheck = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11() {
        return regenerator_default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                clearInterval(this.requestStatusCheckId);

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function cancelRequestStatusCheck() {
        return _cancelRequestStatusCheck.apply(this, arguments);
      }

      return cancelRequestStatusCheck;
    }()
  }, {
    key: "deleteShareTransferStore",
    value: function () {
      var _deleteShareTransferStore = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee12(encPubKey) {
        var currentShareTransferStore;
        return regenerator_default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.getShareTransferStore();

              case 2:
                currentShareTransferStore = _context12.sent;
                delete currentShareTransferStore[encPubKey];
                _context12.next = 6;
                return this.setShareTransferStore(currentShareTransferStore);

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function deleteShareTransferStore(_x11) {
        return _deleteShareTransferStore.apply(this, arguments);
      }

      return deleteShareTransferStore;
    }()
  }, {
    key: "resetShareTransferStore",
    value: function () {
      var _resetShareTransferStore = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee13() {
        var metadata, shareTransferStorePointer;
        return regenerator_default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                metadata = this.tbSDK.getMetadata();
                shareTransferStorePointer = {
                  pointer: new external_bn_js_default.a(Object(eccrypto_["generatePrivate"])())
                };
                metadata.setGeneralStoreDomain(this.moduleName, shareTransferStorePointer);
                _context13.next = 5;
                return this.tbSDK.syncShareMetadata();

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function resetShareTransferStore() {
        return _resetShareTransferStore.apply(this, arguments);
      }

      return resetShareTransferStore;
    }()
  }]);

  return ShareTransferModule;
}();

/* harmony default export */ var src_ShareTransferModule = (ShareTransferModule_ShareTransferModule);
// CONCATENATED MODULE: ./index.ts





/***/ })
/******/ ]);